<script type="ts">
  import { createEventDispatcher } from 'svelte';
  import Select from 'svelte-select/Select.svelte';

  import type { Pagination } from './types.svelte';

  export let shouldShowlabel = false;
  export let pagination: Pagination;

  const dispatch = createEventDispatcher();
  const pageSizes = [10, 25, 50, 100];

  function changePageSize(event) {
    dispatch('pageChange', { ...pagination, pageSize: event.detail.value });
  }
</script>

{#if shouldShowlabel}
  <label for="itemsPerPage">Items per page</label>
{/if}
<div class="w-32">
  <Select
    id="itemsPerPage"
    items={pageSizes}
    on:change={changePageSize}
    placeholder="Page size"
    searchable={false}
    clearable={false}
    showChevron
    value={{ value: pagination.pageSize, label: pagination.pageSize }}
    containerStyles="background-color: #FFF5EA;"
  />
</div>
